import { BackednResponse } from "@shared/lib/types";

import { BRIEF_DRAFTING_QUERY_KEY } from "@entities/brief/lib/constants";
import { ToastService } from "@shared/lib/services";
import { IDraftingResponse } from "@shared/lib/types/drafting";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BriefService } from "../../services/brief.service";

export function useGetDraftById(draftingId: string) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery<
    BackednResponse<IDraftingResponse>
  >({
    queryKey: BRIEF_DRAFTING_QUERY_KEY(draftingId),
    queryFn: () => BriefService.getDrafting(draftingId),
    enabled: !!draftingId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    drafting: data?.data,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
}
